import { render, staticRenderFns } from "./Contributors.vue?vue&type=template&id=c915bd7e&scoped=true&"
import script from "./Contributors.vue?vue&type=script&lang=js&"
export * from "./Contributors.vue?vue&type=script&lang=js&"
import style0 from "./Contributors.vue?vue&type=style&index=0&id=c915bd7e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c915bd7e",
  null
  
)

export default component.exports